import type { FEAvailableSystemParamMetadata } from "../models";
import { isValidPositiveNumber } from "./numbers.helpers";

export type IFeSystemParamsBySiteStore = Record<
  number,
  FEAvailableSystemParamMetadata
>;

/**
 * Resolves effective site params without merging: dedicated site row when present,
 * otherwise the company-wide params passed in (store root, not matched metadata).
 */
export const pickEffectiveSystemParamsFromCompanyStore = ({
  companyParams,
  paramsBySite,
  siteId,
}: {
  companyParams?: FEAvailableSystemParamMetadata;
  paramsBySite?: IFeSystemParamsBySiteStore;
  siteId?: number | null;
}): FEAvailableSystemParamMetadata | undefined => {
  if (!isValidPositiveNumber(siteId)) {
    return companyParams;
  }

  const direct = paramsBySite?.[siteId];
  if (direct !== undefined) {
    return direct;
  }

  return companyParams;
};
